import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import Button from "../../../../components/Button";
import { apollo } from "../../../../utils/apollo";
import { CREATE_SHAFAFIYA_POLICY } from "../../../../utils/graphql";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
function ShafafiyaPolicyCreateForm({ integration }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    emiratesId: "",
    unifiedId: "",
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.emiratesId) {
      toast.error("Emirates ID is required.");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await apollo.mutate({
        mutation: CREATE_SHAFAFIYA_POLICY,
        variables: {
          input: {
            integrationUuid: integration.integrationUuid,
            emiratesId: formData.emiratesId,
            unifiedId: formData.unifiedId || null,
          },
        },
      });
      if (data?.createShafafiyaPolicy) {
        toast.success("Shafafiya member processed successfully!");
        navigate("/policies");
      } else {
        toast.error("Failed to create Shafafiya member.");
      }
    } catch (error) {
      toast.error(error.message || "Error executing member push.");
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2"
    >
      <div className="px-4 py-6 sm:p-8">
        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div className="sm:col-span-3">
            <TextInput
              label={t("Emirates ID")}
              name="emiratesId"
              get={formData.emiratesId}
              set={(val) =>
                setFormData({
                  ...formData,
                  emiratesId: val,
                })
              }
              placeholder={t("784-XXXX-XXXXXXX-X")}
              required
            />
          </div>

          <div className="sm:col-span-3">
            <TextInput
              label={t("Unified ID")}
              name="unifiedId"
              get={formData.unifiedId}
              set={(val) =>
                setFormData({
                  ...formData,
                  unifiedId: val,
                })
              }
              placeholder={t("Unified Number (Optional)")}
            />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
        <Button onClick={() => navigate("/policies")} type="button" secondary>
          {t("Cancel")}
        </Button>
        <Button type="submit" disabled={submitting}>
          {submitting ? t("common.processing") : t("policy.create_member")}
        </Button>
      </div>
    </form>
  );
}
export default ShafafiyaPolicyCreateForm;
